<template>
  <div>
    <admin />
  </div>
</template>

<script>
import admin from '@/layouts/admin'

export default {
  components: {
    admin
  }  
}
</script>


// WEBPACK FOOTER //
// src/pages/index.vue